import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import API from "./../../utils/api";

// Style
import "./Home.scss";

// Assets
import skull from "../../assets/images/home/skull.svg";
import clearberry from "../../assets/images/home/CodeBerry.svg";

// Libraries
import { Link } from "react-router-dom";

// Consts
import { TOTAL_TIME } from "../../utils/consts";
import { storage } from "../../services/config/storage";
import { GC } from "../../services/config/gameCenteService";

const Home = (props) => {
  const history = useHistory();
  const gameDetails = storage.get.gameDetails();

  const beginGame = () => {
    localStorage.removeItem("minutes");
    localStorage.removeItem("seconds");
    let levelsDone = storage.get.levelsDone();
    let timeRemaining = storage.get.timeRemaining();
    if (timeRemaining === 0) levelsDone = 9;
    if (!levelsDone) {
      GC.createGameMasterSession();
      levelsDone = 0;
    } 
    console.log("LEVEL_DONE", levelsDone);
    switch (levelsDone) {
      case 0:
        history.push("/level-dos");
        break;
      case 1:
        history.push("/level-nueve");
        break;
      case 2:
        history.push("/level-ocho");
        break;
      case 3:
        history.push("/level-seis");
        break;
      case 4:
        history.push("/level-diez");
        break;
      case 5:
        history.push("/level-tres");
        break;
      case 6:
        history.push("/level-cinco");
        break;
      case 7:
        history.push("/level-cuatro");
        break;
      case 8:
        history.push("/level-siete");
        break;
      // case 8:
      //   history.push("/level-nueve";
      //   break;
      // case 9:
      //   history.push("/level-diez";
      //   break;
      case 9:
        history.push("/game-end");
        break;
      default:
        history.push("/home");
        break;
    }
  };

  return (
    <div className="component-home">
      {/* <img id="skull" src={skull} alt="skull" /> */}
      <div className="img-container">
        {
          gameDetails?.mediaUrl ?
            <img id="skullberry" className="custom-logo-image" src={gameDetails.mediaUrl} alt="skull" /> :
            <img id="skullberry" src={clearberry} alt="skull" />
        }
        {
          gameDetails?.organizationName &&
          <p style={{ position: 'relative', fontSize: '16px', fontWeight: '200', bottom: '28px' }}>
            powered by <span style={{ fontWeight: '700' }}>{gameDetails.organizationName}</span>
          </p>
        }
      </div>
      <div id="rules" className="max-width-wrapper">
        <p id="rules-main">
          Each level of this game is unique. You’ll need to think out-of-the box
          to figure out the solution for each level. There is no uniform logic
          or move, just figure each level on the go and as quickly as possible.
        </p>
        <p id="rules-submain">So ahoy, clear it out !</p>
      </div>
      <div className="play-div">
        <div className="data-div">
          <div className="level-num">
            <div className="level-header">Levels</div>
            <div className="total-levels">9</div>
          </div>
          <div className="divider"></div>
          <div className="total-time">
            <div className="time-header">Time</div>
            <div className="time">
              <div className="num">7</div>
              <div className="min">min</div>
            </div>
          </div>
        </div>
        <div className="button-div">
          <div className="top-btn" onClick={beginGame}>
            START GAME
          </div>
          <div className="bottom-btn">START GAME</div>
        </div>
      </div>
    </div>
  );
};

export default Home;
